import { BillingProductBlockReason } from '../config';

type GetBillingProductBlockReasonParams = {
  canEditProducts: boolean;
};

export const getBillingProductBlockReason = (
  params: GetBillingProductBlockReasonParams,
): BillingProductBlockReason | undefined => {
  const { canEditProducts } = params;

  if (canEditProducts) {
    return undefined;
  }

  return 'noPermission';
};
